import { Routes, Route, Navigate } from "react-router-dom";

import Login from "../pages/auth/Login";
import ClientDashboard from "../pages/client/ClientDashboard";
import ContactPage from "../pages/client/ContactPage";
import ManagerDashboard from "../pages/manager/ManagerDashboard";
import EngineerDashboard from "../pages/engineer/EngineerDashboard";
import ForgotPassword from "../pages/auth/ForgetPassword";
import PhaseMaster from "../pages/admin/PhaseMaster";
import TaskMaster from "../pages/admin/TaskMaster";
import RoleMaster from "../pages/admin/RoleMaster";
import AccessControl from "../pages/admin/AccessControl";
import UserMaster from "../pages/admin/UserMaster";
import MailLogs from "../pages/admin/MailLogs";
import ProjectMaster from "../pages/project/ProjectMaster";
import ProjectAdd from "../pages/project/ProjectAdd";
import ReportCategoryMaster from "../pages/admin/ReportCategoryMaster";
import DiscussionTopicMaster from "../pages/admin/DiscussionTopicMaster";
import ProjectReports from "../pages/reports/ProjectReports";
import ReportApproval from "../pages/reports/ReportApproval";
import DeletedReports from "../pages/reports/DeletedReports";
import FeedbackLog from "../pages/reports/FeedbackLog";
import WorkSchedule from "../pages/workschedule/WorkSchedule";
import AdminDashboard from "../pages/admin/AdminDashboard";
import EngineerProjects from "../pages/engineer/EngineerProjects";
import EngineerStakeholders from "../pages/engineer/EngineerStakeholders";
import ClientReports from "../pages/client/ClientReports";
import ProjectList from "../pages/project/ProjectList";
import Notifications from "../pages/admin/Notifications";
import AuditLogs from "../pages/admin/AuditLogs";
import ClientTimeline from "../pages/client/ClientTimeline";
import DiscussionModule from "../pages/discussion/DiscussionModule";
import Testimonials from "../pages/testimonials/Testimonials";
import Stakeholder from "../pages/admin/Stakeholder";
import ReportViewer from "../pages/client/ReportViewer";
import ProjectDetail from "../pages/engineer/ProjectDetail";
import ClientLayout from "../layouts/ClientLayout";
import ProjectApproval from "../pages/admin/ProjectApproval";
import ViewProgress from "../pages/client/ViewProgress";
import ReassignProject from "../pages/admin/ReassignProject";
import VisitLogs from "../pages/client/VisitLogs";

import ProtectedRoute from "../components/ProtectedRoute";

function AppRoutes() {
  return (
    <Routes>

      {/* ── AUTH ──────────────────────────────────────────────────── */}
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* ── ADMIN ─────────────────────────────────────────────────── */}
      <Route path="/admin-dashboard" element={
        <ProtectedRoute allowedRoles={["admin"]}>
          <AdminDashboard />
        </ProtectedRoute>
      }
      />


      <Route
        path="/phase-master"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <PhaseMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="/task-master"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <TaskMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="/role-master"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <RoleMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="/access-control"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AccessControl />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-master"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <UserMaster />
          </ProtectedRoute>
        }
      />
      <Route
  path="/mail-logs"
  element={
    <ProtectedRoute allowedRoles={["admin"]}>
      <MailLogs />
    </ProtectedRoute>
  }
/>
      <Route
        path="/project-master"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ProjectMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="/project-add"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ProjectAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/engineer/add-project"
        element={
          <ProtectedRoute allowedRoles={["engineer"]}>
            <ProjectAdd layout="engineer" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/report-category-master"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ReportCategoryMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="/discussion-topic-master"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <DiscussionTopicMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="/project-reports"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ProjectReports />
          </ProtectedRoute>
        }
      />
      <Route
        path="/report-approval"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ReportApproval />
          </ProtectedRoute>
        }
      />
      <Route path="/deleted-reports" element={<ProtectedRoute allowedRoles={["admin"]}><DeletedReports /></ProtectedRoute>} />
      <Route path="/feedback-log" element={<ProtectedRoute allowedRoles={["admin"]}><FeedbackLog /></ProtectedRoute>} />
      <Route
        path="/work-schedule"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <WorkSchedule />
          </ProtectedRoute>
        }
      />
      <Route
        path="/discussion-module"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <DiscussionModule />
          </ProtectedRoute>
        }
      />
      <Route
        path="/testimonials"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Testimonials />
          </ProtectedRoute>
        }
      />
      <Route
        path="/project-list"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ProjectList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ProjectList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/project-approvals"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ProjectApproval />
          </ProtectedRoute>
        }
      />

            <Route
        path="/reassign-project"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ReassignProject />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/reports"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ProjectReports />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/engineers"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Stakeholder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/schedule"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <WorkSchedule />
          </ProtectedRoute>
        }
      />
      <Route
        path="/approvals"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ReportApproval />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stakeholder"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Stakeholder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Notifications />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-logs"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AuditLogs />
          </ProtectedRoute>
        }
      />

      {/* ── MANAGER (Redirected to real admin views with Lucide icons) ──────── */}
      <Route
        path="/manager"
        element={<Navigate to="/admin-dashboard" replace />}
      />
      <Route
        path="/manager/projects"
        element={<Navigate to="/project-list" replace />}
      />
      <Route
        path="/manager/reports"
        element={<Navigate to="/project-reports" replace />}
      />
      <Route
        path="/manager/engineers"
        element={<Navigate to="/stakeholder" replace />}
      />
      <Route
        path="/manager/schedule"
        element={<Navigate to="/work-schedule" replace />}
      />
      <Route
        path="/manager/approvals"
        element={<Navigate to="/report-approval" replace />}
      />

      {/* ── CLIENT ────────────────────────────────────────────────── */}
      <Route
        path="/client-dashboard"
        element={
          <ProtectedRoute allowedRoles={["client"]}>
            <ClientDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client-reports"
        element={
          <ProtectedRoute allowedRoles={["client"]}>
            <ClientReports />
          </ProtectedRoute>
        }
      />
      <Route path="/client-report-view" element={<ProtectedRoute allowedRoles={["client"]}>
        < ReportViewer />
      </ProtectedRoute>} />

      <Route path="/project-timeline" element={<ProtectedRoute allowedRoles={["client"]}>
        < ClientTimeline />
      </ProtectedRoute>} />

      <Route
        path="/client-discussion"
        element={
          <ProtectedRoute allowedRoles={["client"]}>
            <DiscussionModule layout="client" />
          </ProtectedRoute>
        }
      />

      <Route
        path="/client-testimonials"
        element={
          <ProtectedRoute allowedRoles={["client"]}>
            <Testimonials layout="client" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/contact"
        element={
          <ProtectedRoute allowedRoles={["client"]}>
            <ContactPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/view-progress"
        element={
          <ProtectedRoute allowedRoles={["client"]}>
            <ViewProgress />
          </ProtectedRoute>
        }
      />

      <Route
  path="/visit-logs"
  element={
    <ProtectedRoute allowedRoles={["client"]}>
      <VisitLogs />
    </ProtectedRoute>
  }
/>

      {/* ── ENGINEER ──────────────────────────────────────────────── */}
      {/* Dashboard and project list */}
      <Route
        path="/engineer"
        element={
          <ProtectedRoute allowedRoles={["engineer"]}>
            <EngineerDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/engineer/projects"
        element={
          <ProtectedRoute allowedRoles={["engineer"]}>
            <EngineerProjects />
          </ProtectedRoute>
        }
      />

      <Route
        path="/engineer/project/:id"
        element={
          <ProtectedRoute allowedRoles={["engineer", "admin"]}>
            <ProjectDetail />
          </ProtectedRoute>
        }
      />

      <Route
        path="/engineer/project/:id/reports"
        element={
          <ProtectedRoute allowedRoles={["engineer"]}>
            <ProjectReports layout="engineer" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/engineer/project/:id/work-schedule"
        element={
          <ProtectedRoute allowedRoles={["engineer"]}>
            <WorkSchedule layout="engineer" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/engineer/project/:id/testimonials"
        element={
          <ProtectedRoute allowedRoles={["engineer"]}>
            <Testimonials layout="engineer" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/engineer/project/:id/discussion"
        element={
          <ProtectedRoute allowedRoles={["engineer"]}>
            <DiscussionModule layout="engineer" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/engineer/project/:id/stakeholders"
        element={
          <ProtectedRoute allowedRoles={["engineer", "admin"]}>
            <EngineerStakeholders />
          </ProtectedRoute>
        }
      />



    </Routes>
  );
}

export default AppRoutes;